import { injectGlobal } from "emotion";

injectGlobal(`
	*:focus {
		outline: none !important;
	}
`);
